// ==========================================================================
// Sticky searchbar
// ==========================================================================

class NavigationMinimap {
  constructor() {
    this.mapWraps = [...document.querySelectorAll('.js-map-wrap')];
    this.init();
  }

  init() {
    this.mapWraps.forEach(sublist => {
      const anchors = [...sublist.querySelectorAll('[data-pin]')];

      anchors.forEach(anchor => {
        anchor.pinStyles = anchor.getAttribute('data-pin');
        anchor.minimapElement = sublist.querySelector('.pins');

        if (!anchor.pinStyles || !anchor.minimapElement) return;

        this.createPin(anchor);

        anchor.addEventListener('mouseenter', () => {
          this.showPin(anchor);
        });

        anchor.addEventListener('mouseleave', () => {
          this.hidePin(anchor);
        });
      });
    });
  }

  createPin(anchor) {
    anchor.span = document.createElement('span');
    anchor.span.setAttribute('style', anchor.pinStyles);
    anchor.minimapElement.appendChild(anchor.span);
  }

  showPin(anchor) {
    anchor.span.classList.add('show');
  }

  hidePin(anchor) {
    anchor.span.classList.remove('show');
  }
}

export default new NavigationMinimap();



// WEBPACK FOOTER //
// ./src/js/navigation-minimap.js